    import {sortBy,cart} from "../../store"
    let setCart
    cart.subscribe((value)=>{
      setCart = value
    })

export const handleCart = (product,qty) => {
    const productId = product.id;
    if(setCart.findIndex((product) => product.id === productId) !== -1){
      const setCarts = setCart.reduce((cartAcc, product) =>{
        if (product.id === productId) {
              cartAcc.push({
                ...product,
                qty: product.qty + qty,
                sum: product.price * (product.qty + qty),
          });
          } else {
              cartAcc.push(product);
          }
          return cartAcc;
            }, []);
        return cart.update(value=> value = setCarts);
      }
      cart.update((prev) => prev =  [
            ...prev,
            { ...product,qty: qty, sum : product.price * product.qty },
      ])
}

export const decrementQty = (productId) => {
  if (setCart.findIndex((product) => product.id === productId) !== -1) {
      const setCarts = setCart.reduce((cartAcc, product) => {
          if (product.id === productId) {
              cartAcc.push({
                  ...product,
                  qty: product.qty - 1,
                  sum: product.price * (product.qty - 1),
              });
          } else {
              cartAcc.push(product);
          }
          return cartAcc;
      }, []);
      return cart.update(value=> value = setCarts);
  }
};

export const getCartTotal = (cartItems) => {
  var total = 0;
  var items = 0;
  for (var i = 0; i < cartItems.length; i++) {
  items = cartItems[i].qty * cartItems[i].price
  total = total + items;
  }
  return total;
}
